define(function (require) {
	//views
	const MapView = require('civicsViews/agencymap_view/v_agencymap');
	const mapToggleView = require('./v_lov_map_toggle');

	//templates
	const tpl = require('./t_lov_location_selection.hbs');

	//models
	const IPSModel = require('civicsBase/ipsModel');

	//Utilities
	const view_manager = require('civicsUtils/view_manager');
	//This needs to be moved into the common utilities.
	const loading_manager = require('civicsUtils/loading_manager');

	//extensions - (See bottom of file)
	const location_selection_logic_2207 = require('./2207_location_selection_logic')
	const location_selection_logic_2204 = require('./2204_location_selection_logic');

	const CN = require('civicsUtils/constants');

	/********************************************************************* */
	/* 	IMPORTANT: This object is extended in location_selection_logic.	   */
	/*	If you can't find this.whatever in this file, look there.		   */
	/********************************************************************* */
	return Marionette.LayoutView.extend({
		className: "location-selection",
		extent: '',
		template: tpl,
		regions: {
			mapRegion: '@ui.mapRegionDiv',
			mapToggleRegion: '@ui.mapToggle',
		},
		ui: {
			addressOrParcel: '.address-or-parcel',
			addressWrapper: '.address-wrapper',
			autocompleteAddressInput: '.autocomplete-address input',
			autocompleteParcelInput: '.autocomplete-parcel input',
			autocompleteCombinedSiteInput: '.autocomplete-combined-site input',
			combinedSiteWrapper: '.combined-site-wrapper',
			leftSide: '.left-side',
			locateMeButton: '.locate-me',
			locationDetailsTextArea: 'textarea.site-location-details',
			mapRegionDiv: '.myProjectMap',
			mapToggle: '.map-toggle-region',
			mapWrapper: '.map-wrapper',
			messagesDiv: '.address-field-wrapper .messages',
			parcelWrapper: '.parcel-wrapper'
		},
		events: {
			'keyup @ui.autocompleteAddressInput': 'autocompleteFieldsTyping',
			'keyup @ui.autocompleteParcelInput': 'autocompleteFieldsTyping',
			'change @ui.addressOrParcel': 'addressOrParcelChanged',
			'focus @ui.locationDetailsTextArea': 'onLocationDetailsFocus',
			'keyup @ui.autocompleteCombinedSiteInput': 'autocompleteFieldsTyping',
			'click @ui.mapToggle': 'mapToggled',

		},
		activeMapLayers:null,
		initialize: function (options) {
			this.viewReady = false;
			this.config = _.isEmpty(options.config) ? {} : options.config;
			this.assetsOnMapEnabled = this.config.cdrNewLocation.assetsOnMap;
			this.providedLocationDetails = options.providedLocationDetails;
			if (_.isEmpty(this.config.globalConfig)) {
				this.config.globalConfig = view_manager.globalConfig().toJSON();
			}
			//console.log('Config: ', this.config);
			this.countryCode = this.getCountryCode(this.config.globalConfig.cultureInfo);
			//providedSite can be from clone, or saved instrument kinda thing. Basically, when the map loads up, show this site on it, as if it was just selected.
			this.providedSite = options.providedSite;
			//used to ensure we don't try to alter the UI before render finishes.
			//The location services will clear/fill the autocomplete field, and can finish before the render.
			this.isRenderedPromise = $.Deferred();
			this.mapReadyPromise = $.Deferred();
			this.mapExtentPromise = $.Deferred();
			this.locationServicesAvailablePromise = $.Deferred();

			this.primarySiteHiddenByConstraints = this.checkPrimarySiteConstraints(this.config);
			// if (!this.primarySiteHiddenByConstraints) {
			// 	this.determineSiteTypeToUse();
			// 	this.setupMapAndExtent(options);
			// 	this.setupLocationServices();
			// }
			this.determineSiteTypeToUse();
			this.setupMapAndExtent(options);
			this.setupLocationServices();

			if (this.assetsOnMapEnabled) {
				//we have to build the layer list, so that this.activeMapLayers is built, and can filter
				//the layers on the maplet or the calls to the extent services or AC services
				this.buildLayerList(this.config.primarySiteType, this.config.portalAssetTypes)
			}
		},
		onRender: function () {
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();

			this.isRenderedPromise.resolve();
		},
		onShow: function () {
			this.handleOverlay();

			$.when(this.mapExtentPromise).always(() => {
				//we can't use ESRI AC with the composite component, so we can scrap these parameters.
				var parameters = this.assetsOnMapEnabled ? {}:{
					countryCode: this.countryCode,
					extent: this.extent,
					maxSuggestions: this.config.cdrNewLocation.maxSuggestions,
					location: '',
					f: 'json'
				};
				if (this.assetsOnMapEnabled) {
					this.setupAutocomplete(this.config.cdrNewLocation.compositeMoniker, parameters, this.config.cdrNewLocation.searchExtentSize, this.config.primarySiteType, this.config.portalAssetTypes);
				} else {//set up 2204 seperated fields
					if (this.config.primarySiteType & CN.ADDRESS) {
						this.setupAutocomplete(this.config.cdrNewLocation.addressMoniker, parameters, this.config.cdrNewLocation.searchExtentSize);
					}
					if (this.config.primarySiteType & CN.PARCEL) {
						this.setupAutocomplete(this.config.cdrNewLocation.parcelMoniker, parameters, this.config.cdrNewLocation.searchExtentSize);
					}
				}
			})

			this.displayMap();

			this.on('civics:map-click-results', (res) => {
				this.mapClicked(res, this.config.cdrNewLocation.searchExtentSize);
			});
			this.on('civics:locate-me-clicked', (res) => {
				this.locateMeClicked();
			});
			//this sets up the event handling for no results from autocomplete
			if (this.assetsOnMapEnabled) {
				this.ui.autocompleteCombinedSiteInput.on('requestend', this.autocompleteRequestCompleted.bind(this));
			} else {//2204 fields
				this.ui.autocompleteAddressInput.on('requestend', this.autocompleteRequestCompleted.bind(this));
				this.ui.autocompleteParcelInput.on('requestend', this.autocompleteRequestCompleted.bind(this));
			}

			this.ui.locationDetailsTextArea.val(this.providedLocationDetails);
			this.ui.locationDetailsTextArea.maxlength();
		},
		onLocationDetailsFocus: function () {
			if ($(".additional-information-wrapper").find('.helper-msg').length == 0) {
				this.ui.locationDetailsTextArea.maxlength();
			}//return character counter
		},
		getActiveField: function () {
			let input;
			let activeField = this.getActiveAutocompleteFieldType();
			if (activeField.combined) {
				input = this.ui.autocompleteCombinedSiteInput;
			} else if (activeField.address) {
				input = this.ui.autocompleteAddressInput;
			} else {
				input = this.ui.autocompleteParcelInput;
			}
			return input;
		},
		autocompleteFieldsTyping: function () {
			let input = this.getActiveField();
			var oldVal = input.data('oldValue');
			var val = input.val();
			//check that the oldvalue and the current value don't match. this means they typed something, as opposed to just navigating the text string with arrow keys
			//also check to see if val is short/less than the number of characters to trigger autocomplete. We still want to clear messages and reset the object in that case.
			if ((oldVal != undefined && oldVal != val) || (val != undefined && val.length <= 3)) {
				//first argument is the method being used currently, second is whether to keep the autocomplete field populated
				this.resetLocation({ autocomplete: true }, true);
			}

		},
		//this method is only used pre 2207.
		addressOrParcelChanged: function (e) {
			if ($('.address-or-parcel [type="radio"]:checked').val() == 'address') {
				this.ui.addressWrapper.removeClass('hide');
				this.ui.parcelWrapper.addClass('hide');
			} else {
				this.ui.addressWrapper.addClass('hide');
				this.ui.parcelWrapper.removeClass('hide');
			}
			//clear out the form
			//pass in none as the method. Method indicates what initiated the reset - normally  auto
			//complete, map click, or geolocation. In this case, we simply need to clear it out. It will
			//be set appropriately the next user interaction.
			this.resetLocation({ none: true });
		},
		getActiveAutocompleteFieldType: function () {
			var ret = {
				address: true,
				parcel: false
			};
			if (this.useBothAddressAndParcel) {
				//check the radio buttons.
				if ($('.address-or-parcel [type="radio"]:checked').val() == 'parcel') {
					ret = {
						address: false,
						parcel: true
					};
				}
			} else if (this.useParcel) {
				ret = {
					address: false,
					parcel: true
				};
			}
			//if we use the combined site field, override everything else.
			if (this.assetsOnMapEnabled) {
				ret = {
					combined:true
				}
			}
			return ret;
		},
		//only used pre 2207. this sets the radio button to the correct type when an existing site is loaded.
		setSiteType: function (type) {
			if (type == CN.ADDRESS) {
				$('.address-or-parcel [value="address"]').prop('checked', true).trigger('change');
			} else {
				$('.address-or-parcel [value="parcel"]').prop('checked', true).trigger('change');
			}
		},
		//fires whenever the AC service fetch finishes. we only want to do anything if it's empty.
		autocompleteRequestCompleted: function (args, typedText, response) {
			if (response && response.length == 0) {
				if (this.getActiveAutocompleteFieldType().address) {
					this.showError(i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.NO_RESULTS_RETURNED_ERROR'))
				} else if (this.getActiveAutocompleteFieldType().parcel) {
					this.showError(i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.PARCEL_NO_RESULTS_RETURNED_ERROR'))
				} else {
					this.showError(i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.COMBINED_NO_RESULTS_RETURNED_ERROR'))
				}
			}
		},
		clearAutocomplete: function () {
			//if the view hasn't been rendered, there isn't anything to clear anyways. no need to set up a .done
			if (this.isRenderedPromise.state() == 'resolved') {
				this.ui.autocompleteAddressInput.val('');
				this.ui.autocompleteAddressInput.removeData('oldValue');

				this.ui.autocompleteParcelInput.val('');
				this.ui.autocompleteParcelInput.removeData('oldValue');

				this.ui.autocompleteCombinedSiteInput.val('');
				this.ui.autocompleteCombinedSiteInput.removeData('oldValue');
			}
		},
		displayMap: function () {
			if (this.mapEnabled) {
				this.mapRegion.show(new MapView({
					config: {
						mapConfig: this.mapConfigName,
						channel: this,
						regionId: this.mapRegionId,
					},
					layerList: this.activeMapLayers,
				}));
				this.mapToggleModel = new IPSModel({ mapToggle: true });
				this.mapToggleModel.on('change', () => {
					if (this.mapToggleModel.get('mapToggle')) {
						this.ui.mapWrapper.show(250);
					} else {
						this.ui.mapWrapper.hide(250);
					}
				});
				this.mapToggleRegion.show(new mapToggleView({ mapStateName: this.mapStateName, model: this.mapToggleModel }));

				if (this.assetsOnMapEnabled) {
					// event that updates layers on visibility change
					this.listenTo(this, 'civics:layer-visible', function (mapLayers) {
						this.updateMapLayers(mapLayers);
					});
					// gets active layers on map render
					this.listenTo(this, 'civics:get-active-layers', function (mapLayers) {
						this.updateMapLayers(mapLayers);
					});
				}

			} else {
				this.ui.mapWrapper.hide();
				this.ui.leftSide.hide();
			}
		},
		displayMessage: function (text) {
			if (this.isRenderedPromise.state() == 'resolved') {
				//only show default message for assets on map or newer and if there's no error.
				if (text == null){
					text = '';
					if (this.assetsOnMapEnabled && this.ui.combinedSiteWrapper.find('.error').length <= 0) {
						text = i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.COMBINED_SITE_INITIAL_MESSAGE');
					}
				}
				this.ui.messagesDiv.text(text);
			} else {
				//if we haven't rendered yet, wait until we render then call ourselves again.
				this.isRenderedPromise.done(() => {
					this.displayMessage(text);
				})
			}
		},
		handleOverlay: function () {
			if (!this.primarySiteHiddenByConstraints) {
				loading_manager.loading(true, this);
				//place an overlay while the map is loading. Then continue to show it until all the init calls are finished.
				$.when(this.mapReadyPromise, this.mapExtentPromise, this.locationServicesAvailablePromise).always(() => {
					loading_manager.loading(false, this);
				});
			}
		},
		setupLocationServices: function () {
			this.useLocationServices = this.config.cdrNewLocation.useLocationServices === true;
			this.locationServicesAvailable = false;


			if (this.useLocationServices) {
				this.mapExtentPromise.done(() => {
					//we're grabbing the users location, and passing through whatever is returned in the resolve to the locationservicesAvialable promise.
					this.getUsersLocation(this.extent, this.config.globalConfig.gis.locateMeTimeout).done((coords) => {
						this.locationServicesAvailablePromise.resolve(coords);
					});
				});
			} else {
				this.locationServicesAvailablePromise.resolve(false);
			}

			//these three promises will ALWAYS resolve, regardless of the map, location, or extent status. Once these are resolved, teh view is ready
			//but if we're cloning and have a provided primary site, that sites data will still be fetching.
			$.when(this.locationServicesAvailablePromise, this.mapExtentPromise, this.mapReadyPromise).done(() => {
				//for whatever reason we cant get teh parameters from the promise in a when. Even though we should be able to.
				this.locationServicesAvailablePromise.done((coords) => {
					if (coords !== false) {
						this.showLocateMeButton(true);
						if (this.providedSite == null) {//don't show users location if we have a site to show already, either from clone or saved instrument
							this.getIPSLocationForCoordinates(coords, this.config.cdrNewLocation.searchExtentSize);
						}
					} else {
						this.showLocateMeButton(false);
					}
					if (!this.locationServicesAvailable) {
						$('.map-panel.locate-me').hide();
					}
				});

				this.processProvidedSite(this.providedSite, this.config.cdrNewLocation.searchExtentSize, this.config.isClone);
				this.viewReady = true;
			});
		},
		showLocateMeButton: function (show) {
			this.locationServicesAvailable = show;
		},
		locateMeClicked: function (e) {
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}

			var locateMePromise = this.getUsersLocation(this.extent, this.config.globalConfig.gis.locateMeTimeout);
			locateMePromise.done((coords) => {
				if (coords !== false) {
					this.getIPSLocationForCoordinates(coords, this.config.cdrNewLocation.searchExtentSize);
				} else {//this code should never really fire. If the location is outside of the extent, the locate me button should be hidden.
					this.showError(i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.OUT_OF_EXTENT_ERROR_LOCATE_ME'));
				}
			})
		},
		resetErrorMessages: function () {
			view_manager.resetErrorMessages(this);
		},
		setFieldToValue(displayText) {
			var field = this.getActiveField();
			if (this.isRenderedPromise.state() == 'resolved') {
				field.val(displayText);
				//set the address display text to "oldValue" so we can compare it on keyup events.
				//if it hasn't changed, don't clear the location object.
				field.data('oldValue', displayText);
			} else {
				this.isRenderedPromise.done(() => {
					this.setFieldToValue(displayText);
				})
			}
		},
		setupMapAndExtent: function (options) {
			this.mapStateName = options.mapStateName;
			this.mapConfigName = options.mapConfigName;
			this.mapRegionId = options.mapRegionId;
			this.mapEnabled = (!_.isEmpty(this.config.globalConfig.gis) ? this.config.globalConfig.gis.enabled : false) && !_.isEmpty(this.mapConfigName);

			if (this.mapEnabled) {
				this.fetchMapExtent(this.mapConfigName)
					.done((response) => {
						if (response.extent) {
							this.extent = response.extent;
							this.mapExtentPromise.resolve();
						} else {
							//our backup option is to use the extent from the portlet config
							this.extent = this.getExtentFromConfig(this.config);
							this.mapExtentPromise.resolve();
						}
					})
					.fail(() => {
						this.extent = this.getExtentFromConfig(this.config);
						this.mapExtentPromise.resolve();
					});
				this.mapState = view_manager.getMapState('CIVICS', this.mapStateName);


				this.on("map:ready", function () {
					setTimeout(() => {
						this.mapReadyPromise.resolve();
					}, 500);

				}.bind(this));

				this.on("map:adminfailure", function () {
					setTimeout(() => {
						this.mapReadyPromise.resolve();
					}, 500);

				}.bind(this));

			} else {
				//if the map is disabled, we still need an extent for the autocomplete. we can get that from the config.
				this.extent = this.getExtentFromConfig(this.config);
				this.mapExtentPromise.resolve();
				this.mapReadyPromise.resolve();
			}
		},
		showError: function (errorText) {
			var errorObj = {};
			let field = this.getActiveField();
			errorObj[field.attr('name')] = errorText;
			view_manager.errorToWindow({
				validationError: errorObj
			}, this);
			//clear any messages
			this.displayMessage('');
		},
		submitData() {
			if (!this.viewReady && this.config.isClone) {//if the view hasn't finished loading, but we're cloning a record, return an empty object. This will
				return {};							//cause the extend in the submit process to take the parcel/address data from the cloned record instead.
			}
			var data = {};
			data.location = this.ui.locationDetailsTextArea.val();
			return this.processLocationData(data);
		},
		hideCombinedSite: function(){
			let primarySiteHide = this.config.constraints && this.config.constraints.primarySite && (this.config.constraints.primarySite.hidden || this.config.constraints.primarySite.readOnly);

			if(this.assetsOnMapEnabled && primarySiteHide)
				return ' hide';
			return this.assetsOnMapEnabled ? '' : ' hide';
		},
		templateHelpers: function () {
			
			return {
				mapEnabled: true,
				locationServicesAvailable: this.locationServicesAvailable,
				hideOrShowLocateMeButton: this.locationServicesAvailable ? "" : " hide",
				locationRequired: this.config.isAddressRequired === true,
				hideSiteType: this.assetsOnMapEnabled ? ' hide' : this.useBothAddressAndParcel === false ? ' hide' : '',
				hideAddress: this.assetsOnMapEnabled ? ' hide' : this.useAddress === false ? ' hide' : '',
				//parcel is hidden unless it's the only primary site type allowed.
				hideParcel: this.assetsOnMapEnabled ? ' hide' : this.useParcel === false || this.useBothAddressAndParcel === true ? ' hide' : '',
				hideCombinedSite: this.hideCombinedSite(),
				primarySiteHidden: this.config.constraints && this.config.constraints.primarySite && (this.config.constraints.primarySite.hidden || this.config.constraints.primarySite.readOnly),
				locationDetailsHidden: this.config.constraints && this.config.constraints.primarySite && this.config.constraints.primarySite.hidden,
				locationDetailsDisabled: this.config.constraints && this.config.constraints.primarySite && this.config.constraints.primarySite.readOnly,
			}
		}
	}).extend(function () {
		if (App.options._assetsOnMap) {
			return location_selection_logic_2207;
		}
		return location_selection_logic_2204;
	}());
})
